export default {
  setType(state, payload) {
    state.type = payload
  },
  setFilters(state, payload) {
    state.getFilters = automationList
  },
  setXAxis(state, payload) {
    state.x_axis = automation
  },
  setActiveContextFilters(state, payload) {
    state.activeContextFilters = { ...state.activeContextFilters, ...payload }
  },
}
